/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Daterangepicker_Apply2Inputs */

const id_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terapkan`)
};

const ms_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guna`)
};

const da_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anvend`)
};

const de_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anwenden`)
};

const en_us2_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply`)
};

const es_es2_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar`)
};

const es_mx2_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar`)
};

const fil_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilapat`)
};

const fr_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer`)
};

const it_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applica`)
};

const hu_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alkalmaz`)
};

const nl_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toepassen`)
};

const no_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bruk`)
};

const pl_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zastosuj`)
};

const pt_br2_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar`)
};

const pt_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar`)
};

const ro_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplică`)
};

const fi_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käytä`)
};

const sv_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkställ`)
};

const vi_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Áp dụng`)
};

const tr_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uygula`)
};

const cs_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použít`)
};

const bg_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приложи`)
};

const ru_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Применить`)
};

const uk_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Застосувати`)
};

const ar_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تطبيق`)
};

const hi_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लागू करें`)
};

const th_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นำไปใช้`)
};

const ja_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`適用`)
};

const zh_cn2_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用`)
};

const zh_hant1_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`套用`)
};

const ko_components_daterangepicker_apply2 = /** @type {(inputs: Components_Daterangepicker_Apply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`적용`)
};

/**
* | output |
* | --- |
* | "Apply" |
*
* @param {Components_Daterangepicker_Apply2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_daterangepicker_apply2 = /** @type {((inputs?: Components_Daterangepicker_Apply2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Daterangepicker_Apply2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_daterangepicker_apply2(inputs)
	if (locale === "ms") return ms_components_daterangepicker_apply2(inputs)
	if (locale === "da") return da_components_daterangepicker_apply2(inputs)
	if (locale === "de") return de_components_daterangepicker_apply2(inputs)
	if (locale === "en-US") return en_us2_components_daterangepicker_apply2(inputs)
	if (locale === "es-ES") return es_es2_components_daterangepicker_apply2(inputs)
	if (locale === "es-MX") return es_mx2_components_daterangepicker_apply2(inputs)
	if (locale === "fil") return fil_components_daterangepicker_apply2(inputs)
	if (locale === "fr") return fr_components_daterangepicker_apply2(inputs)
	if (locale === "it") return it_components_daterangepicker_apply2(inputs)
	if (locale === "hu") return hu_components_daterangepicker_apply2(inputs)
	if (locale === "nl") return nl_components_daterangepicker_apply2(inputs)
	if (locale === "no") return no_components_daterangepicker_apply2(inputs)
	if (locale === "pl") return pl_components_daterangepicker_apply2(inputs)
	if (locale === "pt-BR") return pt_br2_components_daterangepicker_apply2(inputs)
	if (locale === "pt") return pt_components_daterangepicker_apply2(inputs)
	if (locale === "ro") return ro_components_daterangepicker_apply2(inputs)
	if (locale === "fi") return fi_components_daterangepicker_apply2(inputs)
	if (locale === "sv") return sv_components_daterangepicker_apply2(inputs)
	if (locale === "vi") return vi_components_daterangepicker_apply2(inputs)
	if (locale === "tr") return tr_components_daterangepicker_apply2(inputs)
	if (locale === "cs") return cs_components_daterangepicker_apply2(inputs)
	if (locale === "bg") return bg_components_daterangepicker_apply2(inputs)
	if (locale === "ru") return ru_components_daterangepicker_apply2(inputs)
	if (locale === "uk") return uk_components_daterangepicker_apply2(inputs)
	if (locale === "ar") return ar_components_daterangepicker_apply2(inputs)
	if (locale === "hi") return hi_components_daterangepicker_apply2(inputs)
	if (locale === "th") return th_components_daterangepicker_apply2(inputs)
	if (locale === "ja") return ja_components_daterangepicker_apply2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_daterangepicker_apply2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_daterangepicker_apply2(inputs)
	return ko_components_daterangepicker_apply2(inputs)
});
export { components_daterangepicker_apply2 as "components.dateRangePicker.apply" }